/**
 * @author Tommy Brière
 * @copyright (c) 2021 Cube Noir
 * @fileoverview a 360 scene. Shoud be a 360 video.
 * */
import React from "react";
import { Link } from "@reach/router";
import { InteractPoint } from "@utils/data";
import { getMediaUrl, useCollected, useUrl } from "@utils/navigation";
import useBodyClass from "@utils/useBodyClass";
import PlaceHeader from "@components/PlaceHeader";
import FloatingPoint from "../FloatingPoint";
import { useI18n } from "../../I18nextProvider";
import { PlaceAlternateProps } from "./index.interface";

function PlaceAlternate({ place, sub, mainContentOnPopup }: PlaceAlternateProps) {
  const index: number = +sub || 0;
  const len = place.imageSrcs.length;
  const prevUrl = useUrl({ type: "place", id: place.id, sub: (index + len - 1) % len });
  const nextUrl = useUrl({ type: "place", id: place.id, sub: (index + 1) % len });
  const collectedObjects = useCollected("collectable");
  const img = place.imageSrcs[index];
  const imgUrl = getMediaUrl(img, "placeAlt");
  const i18n = useI18n();

  const collectedPoints = place.interactPoints.filter((i) => {
    return collectedObjects.indexOf(i.id) >= 0;
  });

  useBodyClass(`place-alt`, "place-alt");

  return (
    <div className="place-360">
      <PlaceHeader place={place} collectedCount={collectedPoints.length} mainContentOnPopup={mainContentOnPopup} />
      <img className="pas-360" src={imgUrl} alt="" draggable={false} />
      <section className="alt-points">
        {place.interactPoints.map((point: InteractPoint) => {
          const isCollected = collectedObjects.indexOf(point.id) >= 0;
          return <FloatingPoint key={point.id} point={point} position={null} isCollected={isCollected} />;
        })}
      </section>
      <Link
        className="precedent"
        to={prevUrl}
        aria-label={i18n.t("place.tourne_gauche")}
        title={i18n.t("place.tourne_gauche")}
      />
      <Link
        className="suivant"
        to={nextUrl}
        aria-label={i18n.t("place.tourne_droite")}
        title={i18n.t("place.tourne_droite")}
      />
    </div>
  );
}

export default PlaceAlternate;
